import React from 'react'

import HomePage from '../../javascript/components/pages/HomePage'

import { createRoot } from 'react-dom/client'

const codename = 'home-page'

// find mounting point in the DOM
const root = createRoot(document.querySelector(`#mount-${codename}-here`))

// render the component
root.render(
  <React.StrictMode>
    <HomePage />
  </React.StrictMode>
)

